exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-c0905f28] .quill-editor .ql-editor {\n  overflow: hidden;\n  padding-top: 0;\n  padding-bottom: 0;\n  cursor: text;\n}\n", ""]);

